export default __webpack_public_path__ + "static/media/gallery-img4.bdeb3336.jpeg";